import React, { Component } from 'react';
import { Button, Modal, Card, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { fetchAndSetFlashMessage, Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import { Link } from 'react-router-dom';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';
import Dropdown from 'react-bootstrap/Dropdown';

import "./index.css";
import Marquee from 'react-fast-marquee';
class ListIVR extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ivrlist: [],
            confirmDelete: false,
            selectedIVRid: '',
            loading: false,
            sizePerPage: 10,
            showLogsModal: false,
            selectedLogs: [],
            logsLoading: false,
            alertMessage: ""
        }
    }
    componentDidMount() {
        fetchAndSetFlashMessage(
            this.props.app.apiPath,
            msg => msg.moduleName === "custom_ivr" && msg.action === "view",
            msg => this.setState({ alertMessage: msg })
        );
        this.getIvrlist();
        const savedSizePerPage = Cookies.get('ivrListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    getIvrlist = () => {
        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/custom/ivr/list/'+userId)
            .then(res => {
                this.setState({
                    ivrlist: res,
                })
            })
            .catch(err => { console.log('Error in fetching IVR List', err) });
    }

    openLogsModal = (ivrId) => {
        const apiPath = this.props.app.apiPath;

        this.setState({ logsLoading: true, showLogsModal: true, selectedLogs: [] });

        Fetcher.get(`${apiPath}/api/obd/get/custom/ivr/${ivrId}`)
            .then(res => {
                this.setState({
                    selectedLogs: res.updationLogs ?? [],
                    logsLoading: false
                });
            })
            .catch(console.error)
            .finally(() => this.setState({ logsLoading: false }));
    }

    closeLogsModal = () => {
        this.setState({
            showLogsModal: false,
            selectedLogs: [],
            logsLoading: false
        });
    }

    confirmDelete = (status, IVRid) => {
        this.setState({
            confirmDelete: status,
            selectedIVRid: IVRid
        });
    }

    deleteBlacklist = () => {
        const blacklistId = this.state.selectedBlId;
        const data = {

        }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/blacklist/' + blacklistId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
            .then(res => {
                Notify.notify(res.message);
                this.getBlacklist();
            })
            .catch(err => {
                console.log('Error in Deleting Blacklist Number', err);
            });
    }

    refreshPage = () => {
        this.setState({ loading: true });
        //window.location.reload();
        setTimeout(() => {
            window.location.reload(false);
        }, 500);
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('ivrListsizePerPage', newSizePerPage);
    }

    deleteIVR = () => {
        const ivrId = this.state.selectedIVRid;
        return Fetcher.post(this.props.app.apiPath + '/api/obd/custom/ivr/' + ivrId, { headers: { "Content-type": "application/json" }, method: 'DELETE'})
            .then(res => {
                Notify.notify(res.message);
                this.getIvrlist();
                this.confirmDelete(false, '')
            })
            .catch(err => {
                console.log('Error in Deleting IVR', err)
                Notify.notify('Error in Deleting IVR');
            });
    }

    render() {

        const ivrlist = this.state.ivrlist;
        let columns = '';
        
            columns = [
            {
                dataField: 'ivrId',
                text: 'Ivr Id',
                sort: false,
                //hidden: true
            },
            {
                dataField: 'ivrName',
                text: 'IVR Name',
                sort: true,
                searchable: true,
                 formatter: (cell, row) => {
                    if (this.props?.app?.role === 'ROLE_SADMIN' || this.props?.app?.role === 'ROLE_USER') {
                    return (
                        <a
                        href={`${this.props.app.urlPrefix}/ivr/${row.ivrId}`}
                        style={{ color: '#007bff', cursor: 'pointer' }}
                        >
                        {cell}
                        </a>
                    );
                        }
                        return <span>{cell}</span>;
                    }

            },{
				dataField: 'context',
				text: 'Context',
				sort: true,
				searchable: true,
                hidden : true
			},{
				dataField: 'createdAt',
				text: 'Created Date',
				sort: false,
				searchable: false
			},{
				dataField: 'updatedAt',
				text: 'Last Updated At',
				sort: false,
				searchable: false,
                style: { width: "236px" },
                formatter: (cell, row) => (
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => this.openLogsModal(row.ivrId)}
                        >
                            View Logs
                        </Button>
                        <span>{cell}</span>
                    </div>
                )
			},{
				dataField: 'status',
				text: 'Status',
				sort: false,
				searchable: false
			},
            ...(this.props?.app?.role !== 'ROLE_SADMIN'
                ? [{
                    dataField: 'action',
                    text: 'Action',
                    sort: false,
                    searchable: false,
                    headerStyle: { width: '130px' }
                }]
                : [])
            ];

        const products = Array.isArray(ivrlist) ? ivrlist.map((ivrlist, index) => {
            
            let action = [];
            action.push(<Dropdown key={`${index}-dropdown`}>
                    <Dropdown.Toggle className="btn-sm" variant="primary">Take Action</Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item key={`${index}-edit-user`} href={`${this.props.app.urlPrefix}/ivr/${ivrlist.id}`}>Edit IVR</Dropdown.Item>
                            <Dropdown.Item key={`${index}-delete-user`} onClick={(e) => { this.confirmDelete(true, ivrlist.id) }} href="#">Delete IVR</Dropdown.Item>
                            </Dropdown.Menu>
                    </Dropdown>);
        
            return {
                ivrId: ivrlist.id,
                ivrName: ivrlist.flowName,
                context: ivrlist.context,
				createdAt: ivrlist.createdAt,
                updatedAt: ivrlist.updatedAt,
				status: ivrlist.status === "1" ? "Completed":"Pending",
                action: action
            };
        }) : []
        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'ivrId',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: products.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                <Card.Header>IVR List</Card.Header>
                <Card.Body>
                    {this.state.alertMessage && <Marquee className="fade alert alert-success show">{this.state.alertMessage}</Marquee>}
                    <div className="campaign-list-table-cont">
                        {<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (<ToolkitProvider keyField="blacklistId" data={products} columns={columns} search bootstrap4>
                                    {props => (<div className="">
                                        Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                        <ClearSearchButton className="btn-primary" {...props.searchProps} />
                                        <Button id="refresh" type="button" className="float-right btn btn-default btn-primary ml-2" onClick={() => this.refreshPage()}>Refresh</Button>	
                                        <hr />
                                        <BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
                                        <PaginationListStandalone {...paginationProps} />
                                    </div>)}
                                </ToolkitProvider>)
                            }
                        </PaginationProvider>}
                    </div>
                    <Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Delete IVR
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to Delete this IVR?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.deleteIVR} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={this.state.showLogsModal} onHide={this.closeLogsModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>IVR Update Logs</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {this.state.logsLoading ? (
                                <div className="text-center my-3">
                                    <Spinner animation="border" role="status" />
                                </div>
                            ) : (
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th className="text-center">Updated At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.selectedLogs && this.state.selectedLogs.length > 0 ? (
                                            this.state.selectedLogs.map((log, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">{log.updationAt}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center text-muted">No logs available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.closeLogsModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                </Card.Body>
            </Card>
        );
    }
}


export default ListIVR;